import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Space } from 'tdesign-react';

export default function BadgeStatus({ label, status }) {
  const isProcessing = status === 'Processing';
  const color = useMemo(() => {
    if (isProcessing) {
      return 'var(--td-brand-color)';
    }
    if (status === 'Error') {
      return 'var(--td-error-color)';
    }
    if (status === 'Success') {
      return 'var(--td-success-color)';
    }
    if (status === 'Warning') {
      return 'var(--td-warning-color)';
    }
    return 'var(--td-text-color-secondary)';
  }, [isProcessing, status]);

  return (
    <Space size='small' align='center'>
      <Circle className={[isProcessing && 'processing']} style={{ backgroundColor: color }} />
      {label}
    </Space>
  );
}

const Circle = styled.div`
  position: relative;
  top: -1px;
  display: inline-block;
  width: 6px;
  height: 6px;
  vertical-align: middle;
  border-radius: 50%;
  background-color: var(--td-brand-color-7);
  &.processing::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid var(--td-brand-color-7);
    box-sizing: border-box;
    border-radius: 50%;
    animation: antStatusProcessing 1.2s ease-in-out infinite;
    content: ' ';
  }
`;
